const comments = [
  {
    name: '漫画迷小陈',
    avatar: 'C',
    date: '2026-07-28',
    rating: 5,
    text: '这个韩漫网站真的太棒了！更新速度比我想象的快得多，而且完全免费，翻译质量也很高。已经推荐给身边所有喜欢看韩漫的朋友了！',
    work: '《秘密恋爱笔记》',
  },
  {
    name: '追更达人',
    avatar: '追',
    date: '2026-07-27',
    rating: 5,
    text: '用这个平台追韩漫快一年了，资源真的很全，基本上想看的都能找到。手机端阅读体验也特别好，通勤路上看看漫画太享受了。',
    work: '《剑与魔法纪元》',
  },
  {
    name: '温馨小屋',
    avatar: '温',
    date: '2026-07-26',
    rating: 5,
    text: '《咖啡馆的午后》是我在这里发现的宝藏韩漫！画风细腻温暖，故事治愈人心。感谢平台收录这么多优质作品，每一部都值得细品。',
    work: '《咖啡馆的午后》',
  },
  {
    name: '悬疑控',
    avatar: '悬',
    date: '2026-07-25',
    rating: 4,
    text: '作为一个悬疑韩漫爱好者，这里的选择太丰富了。《暗夜追踪者》第三季回归第一时间就更新了，翻译团队效率赞一个！',
    work: '《暗夜追踪者》',
  },
  {
    name: '古风迷小李',
    avatar: '古',
    date: '2026-07-24',
    rating: 5,
    text: '《花都王朝》的画风简直美哭了！平台收录的古风韩漫质量都很高，希望以后能引进更多同类型作品。免费的资源能做到这个水准真的很良心。',
    work: '《花都王朝》',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i
          key={s}
          className={`text-xs ${s <= rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
        ></i>
      ))}
    </div>
  );
}

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          读者评论
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来自真实读者的心声，每一份喜爱都是我们的动力
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-heading font-bold text-primary-600">
                    {comment.avatar}
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
              </div>

              <StarRating rating={comment.rating} />

              <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                {comment.text}
              </p>

              <p className="text-xs text-primary-500 mt-3 pt-3 border-t border-background-200/70">
                在读：{comment.work}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}